'use client'

import { Space_Grotesk } from 'next/font/google'
import { BackgroundBeams } from '@/app/_components/_ui/background-beams'

const spaceGrotesk = Space_Grotesk({ 
  subsets: ['latin'],
  variable: '--font-space-grotesk',
  display: 'swap'
})

export default function Changelog() {
    return (
        <div className="min-h-screen w-full relative">
            <BackgroundBeams />
            <div className="container mx-auto px-4 py-24 relative z-10">
                <h1 className={`${spaceGrotesk.className} text-4xl font-bold text-white mb-8`}>
                    Changelog
                </h1>
                <div className="bg-neutral-900/50 p-8 rounded-lg">
                    <h2 className="text-2xl font-semibold text-white mb-4">
                        Alpha Release (EDIT THIS DATE)
                    </h2>
                    <p className="text-gray-300">
                        Welcome to autofoc.us! We're excited to share our alpha release with you. 
                        This marks the beginning of our journey to create a focused, intentional 
                        space for sharing and organizing information.
                    </p>
                </div>
            </div>
        </div>
    )
}
